export default __webpack_public_path__ + "static/media/expl-nn_06_EN.6f1862e0.png";